import React,{useEffect,useState} from 'react'
// animation: name duration timing-function delay iteration-count direction fill-mode;
export default function Entity(props) {
  const [entChange,setEntChange]=useState(true)
 
  useEffect(()=>{
    setEntChange(!entChange)
    props.entoogle(entChange)
    var str=props.MSG+' '+props.Tdata[0]+'s'+' '+props.bzval+' '+props.Tdata[1]+'s '+props.Tdata[2]+' '+props.Tdata[3]+' '+props.Tdata[4];
    document.getElementById('entid').style.animation='none';
    document.getElementById('entid').style.animation=str;
    var netDuration=props.Tdata[0]*1000+props.Tdata[1]*1000+props.Tdata[2]*props.Tdata[0]*1000
    setTimeout(() => {
      document.getElementById('entid').style.animation='none';
    }, netDuration+500);
  },[props.MSG,props.Tdata,props.Repval])
  return (
      <>{props.txorder?<div className='ent square' id='entid' ></div>:<h1 className='ent' id='entid' style={{color:"red"}}>SCLIB</h1>}</>
  )
}
